module.exports = __webpack_public_path__ + "assets/panels/powermaster-30-ad98d2adbc412a58e55ccaa1a327d2c7.svg";